<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CN" id="_idParaDest-2"><span class="CharOverride-2">Also by Mike Lawson</span></p>
<p class="AdCardTitle">The Inside Ring</p>
<p class="AdCardTitle">The Second Perimeter</p>
<p class="AdCardTitle">House Rules</p>
<p class="AdCardTitle">House Secrets</p>
<p class="AdCardTitle">House Justice</p>
<p class="AdCardTitle">House Divided</p>
<p class="AdCardTitle">House Blood</p>
<p class="AdCardTitle">House Odds</p>
<p class="AdCardTitle">House Reckoning</p>
<p class="AdCardTitle">Rosarito Beach</p>
<p class="AdCardTitle">Viking Bay</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_4345-1.vue?6af31985